import { Button, Gap, Group, Header, Heading, MainArea, Page, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRoles } from 'sections/user-management/data/RolesApi';
import { useFeatureFlags } from 'core/app/AppContext';
import { NotFoundPage } from 'core/ui/components/error';
import { RoleTable } from './components/RoleTable';

export function ViewRolesPage() {
  const { t } = useTranslation();
  const { push } = useHistory();
  const { rolesData, isRolesLoading } = useRoles();
  const { flagEnabled } = useFeatureFlags();

  if (flagEnabled('role-management-ui')) {
    return (
      <MainArea>
        <TopArea>
          <AppTopBar />
        </TopArea>
        <Page>
          <Heading>{t('userManagement.roles.view.heading')}</Heading>
          <Gap bottom={30} />
          <Header heading={t('userManagement.roles.view.tableHeading')}>
            <Group>
              <Button variation="primary" onClick={() => push('/user-management/roles/create')}>
                {t('userManagement.roles.view.createButton')}
              </Button>
            </Group>
          </Header>
          <RoleTable roles={rolesData} rolesLoading={isRolesLoading} />
        </Page>
      </MainArea>
    );
  } else {
    return <NotFoundPage />;
  }
}
